import {
  collection,
  getDocs,
  query,
  where,
  writeBatch,
  doc,
  addDoc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";

import { auth, firestoredDB } from "../../config/firebase";

const listCollectionRef = collection(firestoredDB, "Lists");
const cookbookCollectionRef = collection(firestoredDB, "CookBook");

const getCookbookLists = async () => {
  const userId = auth?.currentUser?.uid ?? null;

  try {
    // Ensure the user is authenticated
    if (!userId) {
      console.error("User is not authenticated");

      return null;
    }

    const q = query(listCollectionRef, where("userId", "==", userId));
    const data = await getDocs(q);

    const filteredData = data.docs
      .map((doc) => ({
        ...doc.data(),
        id: doc.id,
        createdAt: doc._document.createTime.timestamp.seconds,
      }))
      .sort((a, b) => a.createdAt - b.createdAt);
    return filteredData;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const addNewCookbookList = async (name) => {
  try {
    const docRef = await addDoc(listCollectionRef, {
      userId: auth?.currentUser?.uid,
      name,
    });

    return true;
  } catch (err) {
    console.error("Error adding new list: ", err);
    return null;
  }
};

const deleteCookbookList = async (id) => {
  try {
    const docRef = doc(firestoredDB, "Lists", id);
    await deleteDoc(docRef);

    return true;
  } catch (err) {
    console.error("Error adding new list: ", err);
    return null;
  }
};
const updateListOrder = async (orderedData) => {
  try {
    const batch = writeBatch(firestoredDB);

    orderedData.forEach((item, index) => {
      const docRef = doc(firestoredDB, "Lists", item.id);
      batch.update(docRef, { order: index });
    });

    await batch.commit();

    console.log("List order updated successfully");
    return true;
  } catch (err) {
    console.error("Error updating list order: ", err);
    return false;
  }
};

const getCookBooksRecipes = async () => {
  try {
    const data = await getDocs(
      cookbookCollectionRef,
      where("userId", "==", auth?.currentUser?.uid)
    );
    const totalRecords = data.docs.map((doc) => {
      return {
        ...doc.data(),
        id: doc.id,
      };
    });

    return totalRecords;
  } catch (err) {
    console.error(err);
    return null;
  }
};
const getCookbookRecipeById = async (id) => {
  try {
    const cookBookDocRef = doc(firestoredDB, "CookBook", id); // Reference to the specific cookbook document
    const cookBookDoc = await getDoc(cookBookDocRef);

    if (cookBookDoc.exists()) {
      return cookBookDoc.data();
    }
  } catch (e) {
    return null;
  }
};

export {
  getCookbookLists,
  updateListOrder,
  getCookBooksRecipes,
  addNewCookbookList,
  deleteCookbookList,
  getCookbookRecipeById,
};
